exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".account-kyc-overview__notice{color:#adadad}.account-kyc-overview__message{margin:28px 0 20px}.account-kyc-overview__feature{-ms-flex-item-align:left;align-self:left;margin-bottom:20px}.account-kyc-overview__feature-text{margin-left:16px;color:#777}.account-kyc-overview__feature-icon{vertical-align:middle}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/containers/Account/Kyc/AccountKycOverview/AccountKycOverview.scss
// module id = 856
// module chunks = 1